import { defineComponent as _defineComponent } from 'vue'
import { faStop } from '@fortawesome/free-solid-svg-icons';
import { jwCheckIcon } from '@/plugins/global-fontawesome';
import Spinner from '@/ui-components/Spinner.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MarkAsSeenButtonView',
  props: {
    lightBackground: { type: Boolean },
    isMarked: { type: Boolean },
    saving: { type: Boolean },
    size: { default: 'default' },
    icon: { default: 'jw-check-icon' }
  },
  emits: ["mark-as-seen-button-click"],
  setup(__props: any) {

const props = __props as { lightBackground?: boolean, isMarked?: boolean, saving?: boolean, size: 'small' | 'default', icon: 'jw-check-icon' | 'stop' };





const FA_ICONS = {
	'jw-check-icon': jwCheckIcon,
	stop: faStop,
};

return { __sfc: true,props, FA_ICONS, Spinner }
}

})